import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isSessionExpired } from '../common/session';
import '../common/common.css';
import Loading from '../loading/loading';
import PasswordInput from '../password/password-input';

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // On mount, check for valid session token
  useEffect(() => {
    const token = localStorage.getItem('facesToken');
    if (token && !isSessionExpired()) {
      navigate('/menu', { replace: true });
    } else {
      localStorage.removeItem('facesToken');
      localStorage.removeItem('facesTokenExpires');
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const response = await fetch(
        process.env.REACT_APP_FACES_API_BASE + '/drm-auth',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ username: email, password: password }),
        }
      );
      const data = await response.json();

      if (data.challenge === 'NEW_PASSWORD_REQUIRED') {
        window.alert('Please enter a new password.');
        navigate('/new-password', { state: { session: data.session } });
      } else if (data.access_token) {
        localStorage.setItem('facesToken', data.access_token);
        localStorage.setItem('facesIDToken', data.id_token);
        localStorage.setItem('facesAdmin', data.is_admin);
        localStorage.setItem('facesStaff', data.is_staff);
        localStorage.setItem('facesCertified', data.is_certified);
        localStorage.setItem('facesInstructor', data.is_instructor);
        localStorage.setItem('facesUserEmail', email);
        if (data.account_id) {
          localStorage.setItem('facesAccountID', data.account_id);
        }
        if (data.expires_in) {
          const expiresAt = Date.now() + data.expires_in * 1000;
          localStorage.setItem('facesTokenExpires', expiresAt.toString());
        }
        navigate('/menu');
      } else {
        window.alert(
          'Login failed: ' + (data.error || 'unknown error').toLowerCase()
        );
      }
    } catch (error) {
      window.alert('Login error. Please try again later.');
      console.error('Login error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) return <Loading />;

  return (
    <form onSubmit={handleSubmit} id="main-form" autoComplete="off">
      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        autoComplete="username"
      />
      <PasswordInput
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="Password"
        showPassword={showPassword}
        setShowPassword={setShowPassword}
        inputId="password-input"
        autoComplete="current-password"
      />
    </form>
  );
}

export default Login;
